import {registerTemplateStats} from "./TemplateStatsService";

export const getUserStats = () => {
    const stats = localStorage.getItem('stats');
    if (stats) {
        return JSON.parse(stats);
    }

    return {subjects: {}, points: {}};
}

export const saveUserStats = stats => {
    localStorage.setItem('stats', JSON.stringify(stats));
}

export const clearUserStats = () => {
    localStorage.removeItem('stats');
}


export const getLongestStreak = (subjectKey) => {
    return updateLongestStreak(subjectKey, 0);
}

export const updateLongestStreak = (subjectKey, streakLength) => {
    const stats = getUserStats();
    let subjectsKey = "subjects";
    if (!(subjectsKey in stats)) {
        stats[subjectsKey] = {};
    }
    const subjects = stats[subjectsKey];
    if (!(subjectKey in subjects)) {
        subjects[subjectKey] = {};
    }
    const subject = subjects[subjectKey];
    if (!subject.longestStreak) {
        subject.longestStreak = 0;
    }
    if (subject.longestStreak < streakLength) {
        subject.longestStreak = streakLength;
        saveUserStats(stats);
    }

    return subject.longestStreak
}

export const registerSolvedProblem = (subjectKey, problem, correct) => {
    registerTemplateStats(subjectKey, problem.templateId, problem.rating, correct);
    if (correct) {
        registerPoints(subjectKey, problem);
    }
}

const registerPoints = (subjectKey, problem) => {
    const userRating = 10 * 1000;
    const decayFactor = 3000;
    const maxPoints = 20;
    const pointsToAdd = Math.round(maxPoints / (1 + Math.pow(10, (userRating - problem.rating) / decayFactor)));
    addPoints(subjectKey, pointsToAdd);
}

const addPoints = (subjectKey, pointsToAdd = 0) => {
    const stats = getUserStats();

    const pointsKey = "points";
    if (!(pointsKey in stats)) {
        stats[pointsKey] = {};
    }
    const points = stats[pointsKey];

    if (!(subjectKey in points)) {
        points[subjectKey] = {};
    }
    const subject = points[subjectKey];

    const todayKey = new Date().toLocaleDateString("da-DK");
    if (!(todayKey in subject)) {
        subject[todayKey] = 0;
    }
    subject[todayKey] += pointsToAdd;

    points[subjectKey] = subject;
    stats[pointsKey] = points;
    saveUserStats(stats);
    return subject[todayKey];
}

export const getPoints = (subjectKey) => {
    return addPoints(subjectKey, 0);
}